// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'

import {
  Spinner,
  Warning,
  Grid,
  Button,
  LabelledDetail
} from '../'

import { PicsaDeductions } from './PicsaDeductions'

import { showAsCurrency } from '../../utils'

const QUERY_PAYSLIP = gql`
  query($id: ID!) {
    payslip(id: $id) {
      id
      payday
      basicGross
      totalGross
      totalDeductions
      nonPicsaDebtDeductions
      payrollrun {
        id
        batchPayment {
          id
        }
      }
    }
  }
`


export const Payslip = ({ id, identityId, onClick, buttonLabel, buttonDisabled, className }) => (
  <Query query={QUERY_PAYSLIP} variables={{ id }}>
    {({ loading, error, data }) => {
      if (loading) {
        return <Spinner />
      }

      if (error) {
        return (
          <Warning>
            Failed to fetch payslip data
          </Warning>
        )
      }

      const { payday, basicGross, totalGross, totalDeductions, nonPicsaDebtDeductions, payrollrun } = data.payslip

      return (
        <div className='payslip'>
          <div className='payslip-header'>
            <div>
              Payday:
              &ensp;
              <span className='slds-text-color_weak slds-size_2-of-3'>
                {moment(payday).format('D MMMM YYYY')}
              </span>
            </div>
            <Button onClick={onClick} disabled={buttonDisabled} className='slds-col_bump-left'>
              {buttonLabel}
            </Button>
          </div>

          <div className='u-font-size-larger slds-p-top_medium slds-p-left_medium'>
            Declared payslip amounts:
          </div>
          <Grid
            columns={4}
            items={[
              <LabelledDetail label='Basic gross' detail={showAsCurrency('R', basicGross)} />,
              <LabelledDetail label='Total gross' detail={showAsCurrency('R', totalGross)} />,
              <LabelledDetail label='Total deductions' detail={showAsCurrency('R', totalDeductions)} />,
              <LabelledDetail label='Non-Picsa debt deductions' detail={showAsCurrency('R', nonPicsaDebtDeductions)} />
            ]}
            className='slds-p-top_x-small slds-p-bottom_small slds-p-left_medium slds-p-right_medium'
          />

          <div className='u-font-size-larger slds-p-top_small slds-p-left_medium'>
            Known Picsa deductions:
          </div>
          {payrollrun
            ? <PicsaDeductions identityId={identityId} batchPaymentId={payrollrun.batchPayment.id} />
            : <Warning iconSize='small' className='slds-p-around_medium'>
                Payslip is not linked to a payroll run.
              </Warning>
          }
        </div>
      )
    }}
  </Query>
)

Payslip.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  buttonLabel: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  className: PropTypes.string
}

Payslip.defaultProps = {
  buttonLabel: 'Select',
  buttonDisabled: false,
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/creditapplication-income/Payslip.js